import { render, staticRenderFns } from "./ValoresManuais.vue?vue&type=template&id=b091f1f8"
import script from "./ValoresManuais.vue?vue&type=script&lang=js"
export * from "./ValoresManuais.vue?vue&type=script&lang=js"
import style0 from "./ValoresManuais.vue?vue&type=style&index=0&id=b091f1f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports